import React, {Component} from 'react';
import { CURRENCY } from '../libs/utils/Const';
import { CSVLink, CSVDownload } from "react-csv";

import $ from 'jquery';
import '../css/dataTables.css';

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};
const Headers =[
    {label: "F. CONTABILIZACIÓN" ,key: "RefDate"},
    {label: "F. VENCIMIENTO" ,key: "DueDate"},
    {label: "ORIGEN" ,key: "TransType"},
    {label: "N° DE ORÍGEN" ,key: "BaseRef"},
    {label: "CUENTA DE CONTRAPARTIDA" ,key: "ContraAct"},
    {label: "INFO. DETALLADA" ,key: "LineMemo"},
    {label: "C/D (ML)" ,key: "Debit"},
    {label: "SALDO VENCIDO (ML)" ,key: "BalDueDeb"},
    {label: "CARGO (ML)" ,key: "Debit"},
    {label: "ABONO (ML)" ,key: "BalDueCred"},
]

class AccountBalance extends Component {
    selectTable = view => {
        let name = "";
        switch (view) {
            case '17':
                name = "Orden venta";
                break;
            case '15':
                name = "Entregas";
                break;
            case '13':
                name = "Factura";
                break;
            case '16':
                name = "Devolución";
                break;
            case '21':
                name = "purchaseReturn";
                break;
            case '24':
                name = "Pago";
                break;
            case '67':
                name = "transfers";
                break;
            case '1250000001':
                break;
            case '59':
                name = "transfersEntry";
                break;
            case '60':
                name = "transfersOutput";
                break;
            case '14':
                name = "NC";
                break;
            case '22':
                name = "PurchaseOrder";
                break;
            case '20':
                name = "GoodsReceipt";
                break;
                
            case '1470000113':
                name = "PurchaseRequest";
                break;
            case '162':
                name = "inventoryRevaluation";
                break;
            
            case '18':
                name = "purchaseInvoice";
                break;
            case '30':
                name = "outgoingPayment";
                break;
            default:
                break;
        }

        return name;
    };

    closeAccoutBalance = () => {
        $('#accoutBalanceModal').modal('hide');
    };

    handleChange = (event,index)=>{
        const {AccountBalanceData,openAccountBalance} = this.props;
        let data = AccountBalanceData;
        let change = event.nativeEvent.target.value;
        if(index === 1){
            data.DocDate = !data.DocDate;
        }else if(index === 2){
            data.FirstDay = change;
        }else if(index === 3){
            data.LastDay = change;
        }else if(index === 4){
            data.Visualize = !data.Visualize;
        }else if(index === 5){
                data.VisualizeNum = change !== '' ? change : 0;
        }else if(index === 6){
            data.OnlyUnreconciled = !data.OnlyUnreconciled;
        }
        
        openAccountBalance(data);

    }


    render(){
        const {CardCodeBalance, AccountBalan ,newOrderModel,AccountBalanceData} = this.props;
        let CardBalance = CardCodeBalance ? CardCodeBalance[0] : []
        let accountBalan = AccountBalan ? AccountBalan : [];
        
        return(
          <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="accoutBalanceModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
              <div className="modal-content">
                <div className="modal-header text-white" style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                  <h5 className="modal-title" id="exampleModalLongTitle">Saldo de cuenta</h5>
                  <button type="button" className="close" onClick={this.closeAccoutBalance} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">

                <div className="row">
                    {/*Primer columna*/}
                  <div className="col-12 col-md-6">
                      {/*CardCode*/}
                      <div className="input-group mb-3">
                          <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">Código SN</span>
                          </div>
                              <input type="text" className="form-control" id="txtPartner" disabled = {true} value={AccountBalanceData.CardCode || ''} />
                      </div>
                       {/*Nombre*/}
                       <div className="input-group mb-3">
                          <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                          </div>
                              <input type="text" className="form-control" id="txtPartner" disabled={true} value={newOrderModel.CardName || ''} />
                                
                      </div>
                       {/*Saldo de cuenta*/}
                       <div className="input-group mb-3">
                          <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">
                            <span className="d-none d-xl-inline">Saldo de cuenta</span>
                            <span className="d-inline d-xl-none">Saldo</span>
                        </span>
                          </div>
                              <input type="text" className="form-control" id="txtPartner" disabled={true} value={CardBalance ? formatNumber.new(CardBalance.Balance) : ''} />
                                
                      </div>
                       {/*Entregas*/}
                       <div className="input-group mb-3">
                          <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">Entregas</span>
                          </div>
                              <input type="text" className="form-control" id="txtPartner" disabled={true} value={CardBalance ? formatNumber.new(CardBalance.DNotesBal) : ''} />
                                
                      </div>
                       {/*Pedidos*/}
                       <div className="input-group mb-3">
                          <div className="input-group-prepend">
                              <span className="input-group-text font-weight-bold" id="basic-addon1">Pedidos</span>
                          </div>
                              <input type="text" className="form-control" id="txtPartner" disabled={true} value={CardBalance ? formatNumber.new(CardBalance.OrdersBal) : ''} />
                                
                      </div>
                  </div>
                    
                  {/*Segunda columna*/}
                  <div className="col-12 col-md-6">

                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <div className="input-group-text">
                          <input type="checkbox" id="Fconta" aria-label="Checkbox for following text input" checked={AccountBalanceData.DocDate} onChange={(event) => this.handleChange(event, 1)} />&nbsp;
                          <span className="font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">F. Contabilización</span>
                                <span className="d-inline d-xl-none">F. Contab.</span>
                            </span>
                        </div>
                      </div>
                    </div>
                    {/*DESDE*/}
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                          <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                      </div>
                      <input
                          id="fechaInicioAccount" 
                          style={{
                              important: true,
                              backgroundColor: 'transparent',
                              borderColor: '#ced4da',
                              color: '#000',
                          }}
                          className="form-control"
                          type='date'
                          autoComplete="off"
                          value={AccountBalanceData.FirstDay || ''}
                          onChange ={(event)=>this.handleChange(event,2)}
                      />
                    </div>
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input
                          id="fechaFinAccount"
                          style={{
                              important: true,
                              backgroundColor: 'transparent',
                              borderColor: '#ced4da',
                              color: '#000',
                          }}
                          className="form-control"
                          type='date'
                          autoComplete="off"
                          value={AccountBalanceData.LastDay || ''}
                          onChange ={(event)=>this.handleChange(event,3)}
                        />                
                    </div>
                    {/*VISUALIZAR*/}
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <div className="input-group-text">
                          <input type="checkbox" id="Fconta" aria-label="Checkbox for following text input" checked={AccountBalanceData.Visualize} onChange ={(event)=>this.handleChange(event,4)}/>&nbsp;
                          <span className="font-weight-bold" id="basic-addon1">  Visualizar</span>
                        </div>
                      </div>
                      <input
                          id="txtPostingDate"
                          style={{
                              important: true,
                              backgroundColor: 'transparent',
                              borderColor: '#ced4da',
                              color: '#000',
                          }}
                          className="form-control"
                          type='numeric'
                          autoComplete="off"
                          value={AccountBalanceData.VisualizeNum || ''}
                          onChange ={(event)=>this.handleChange(event,5)}
                        /> 
                        <span className="input-group-text font-weight-bold">
                        <span className="d-none d-xl-inline">Últimas operaciones</span>
                        <span className="d-inline d-xl-none">Últ. Op.</span>
                    </span>
                    </div>  
                    {/*VISUALIZAR*/}
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <div className="input-group-text">
                          <input type="checkbox" id="Fconta" aria-label="Checkbox for following text input" checked={AccountBalanceData.OnlyUnreconciled} onChange={(event) => this.handleChange(event, 6)} />&nbsp;
                          <span className="font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Visualizar sólo operaciones no reconciliadas</span>
                                <span className="d-inline d-xl-none">Solo no reconciliadas</span>
                            </span>
                        </div>
                      </div>
                    </div>                            
                  </div>
                </div>

                <div className="w-100 table-scroll tab-pane" role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{maxHeight: 2000, paddingTop: 5}}>       
                  <div style={{marginBottom: 30}}>         
                    <div style={{height: 400, overflow: 'auto'}}>
                      <table
                        className="display table-hover"
                        style={{width: '100%', marginBottom: 40, marginRight: -3000}}>
                        <thead className="table-header-yellow">
                          <tr style={{textAlign: "center"}}>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  #
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  F. contabilización
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  F. vencimiento
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  Origen
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  N° de orígen
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  Cuenta de contrapartida
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  Info. detallada
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  C/D (ML)
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  Saldo vencido (ML)
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  Cargo (ML)
                              </td>
                              <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                  Abono (ML)
                              </td>
                          </tr>
                        </thead>
                        <tbody>
                            {accountBalan.map((item, index) => {
                              return (     
                                  <tr style={{
                                      maxHeight: 10,
                                      paddingTop: 8,
                                      paddingBottom: 8}}>
                                    <td className="sticky-column"
                                        style={{backgroundColor:'#FFF'}}>
                                        {index+1}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {item.RefDate}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {item.DueDate}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {  this.selectTable(item.TransType)}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {item.BaseRef}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {item.ContraAct}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {item.LineMemo}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {formatNumber.new(item.Debit || item.Credit )}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {formatNumber.new(item.BalDueDeb)}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {formatNumber.new(item.Debit )}
                                    </td>
                                    <td
                                        className="overflow-visible"
                                        style={{textAlign: 'center', maxWidth: 800}}>
                                        {formatNumber.new(item.BalDueCred || item.Credit)}
                                    </td>
                                  
                                  </tr>
                                );
                            })}
                        </tbody> 
                      </table>
                    </div>
                  </div>
                </div>
                                        
                    
                  
                </div>
                <div className="modal-footer">
                {accountBalan.length > 0 && <CSVLink className="btn btn-success" data={accountBalan} headers={Headers}  filename ={"AccountBalance.csv"}   >
                Exportar CSV 
                </CSVLink>}
                  <button type="button" className="btn btn-secondary" onClick={this.closeAccoutBalance}>Cerrar</button>
                </div>
              </div>
            </div>
          </div>
          

          
        );
    }
}


export default AccountBalance;